import React, { useCallback } from "/vendor/react";
import gql from "/vendor/graphql-tag";import {
  useApolloClient
} from "/lib/component/util";


const openModel = gql`
  mutation OpenSwitcher {
    toggleModal(modal: CREATE_WORKORDER_MODAL) @client
  }
`;

const WorkOrderAction = () => {
	const client = useApolloClient();
	const handleClick = useCallback(() => {
	
    	client.mutate({ mutation: openModel });
  }, [client]);

	const handleKeyDown = (event: any) => {
		if (event.key === 'Enter') {
			handleClick();
		}
	}

	return (
			<button style={{ 
				right: 10,
				left: "auto",
				float: "right",
				marginLeft: "10px",
				backgroundColor: "#00a3b5", 
				color: "white", 
				padding: "10px 20px", 
				borderRadius: "5px", 
				cursor: "pointer" 
				}} 
				onClick={handleClick}
				onKeyDown={handleKeyDown}
			>
				<span>Create Work Order</span>
			</button> 
	);
}

export default WorkOrderAction;
